import axios from 'axios';

import type {
  IUserDeleteParams,
  IUserDeleteRequest,
  IUserDeleteResponse,
} from '@/app-package';

const deleteUser = async (params: IUserDeleteParams) => {
  const config: IUserDeleteRequest = {
    url: `/user/delete/${params.userId}`,
    method: 'post',
    params,
  };

  const { data } = await axios.request<IUserDeleteResponse>(config);

  return data;
};

export default deleteUser;
